// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Nf1p","content":"LoadingAlert_content__3sZDT"};